import { factory } from './utils';
import config from './../config';

import httpClient from '@/utils/httpClient';

export default {
  namespaced: true,
  ...factory({
    state: {},
    mutations: {},
    actions: {}
  })('tasks', {
    async getById(id, { projectId }) {
      return httpClient.get(config.apihostname+`/projects/${projectId}/tasks/${id}`);
    },
    async getCollection({ projectId, skip, size, sort }) {
      const params = {};
      if (+skip === skip) {
        params.skip = skip;
      }
      if (+size === size) {
        params.size = size;
      }
      if (sort && sort.length) {
        params.sort = sort;
      }

      const response = await httpClient.get(
        config.apihostname+`/projects/${projectId}/tasks?${new URLSearchParams(params).toString()}`
      );

      return {
        ...params,
        ...response
      };
    },
    async create(data) {
      return httpClient.post(config.apihostname+'/projects/', data);
    },
    async update(id, data) {
      return httpClient.put(config.apihostname+`/projects/${id}`, data);
    },
    async delete(id, { projectId }) {
      return httpClient.delete(config.apihostname+`/projects/${projectId}/tasks/${id}`);
    }
  })
};
